module.exports = "<p>\n  usc-store-mobile works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-store-mobile/usc-store-mobile.component.html
// module id = ../../../../../src/app/components/usc-store-mobile/usc-store-mobile.component.html
// module chunks = main